export default __webpack_public_path__ + "static/media/smart-schedule-2.b4d886ee.png";